import React from "react";
import Enchanted from "../components/projects/enchanted/Main";
import { getSEOData } from "../utils/seo";

export default () => {
  const seoData = getSEOData("enchanted-luxury-apartments-in-thoraipakkam-chennai");
  return <Enchanted seoData={seoData} />;
};
